(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["collection-bundle"] && !window.DesignMode) return;
  try {
    


jQuery(document).ready(function($){
   
 

  console.log( ' File Loaded ' );
 
      jQuery(document).on('click' , '.add-all-to-cart' , function(){
          var clk_btn = jQuery(this).closest('div.coll-bundle-prod-list').find('.add-all-to-cart').data('id');
          // console.log( ' Button  Clicked ' );
          var all_product_ids = new Array();
          for( var  incrmentt = 0 ; incrmentt < jQuery(this).closest('div.coll-bundle-prod-list').find('.product-id').length ; incrmentt++ ){
            var current_product_id = $(jQuery(this).closest('div.coll-bundle-prod-list').find('.product-id')[incrmentt]).val(); 
            if( !all_product_ids.includes(current_product_id) ){
              all_product_ids[all_product_ids.length] = current_product_id;
            }
          }
          // console.log( "All Products" );
          // console.log(all_product_ids);
          var added_products_array = new Array(); 
          ar_add_to_cart(all_product_ids , 0 , added_products_array );
                                                          
      });  
 
    function ar_add_to_cart(all_product_ids , increment , added_products_array ){
       // console.log( 'Increment Is -> ' + increment );
       // console.log( 'All Is -> ' + all_product_ids.length ); 
      if( all_product_ids.length == increment + 1 ){
        setTimeout(function() {
            window.location.href =  window.location.origin + '/cart'; 
        }, 1000);
        
      }  
      var this_add_to_cart_product = all_product_ids[increment];
      if( !all_product_ids[increment] ){
        // window.location.href =  window.location.origin + '/cart';
        return true;
      } 
      if ($.inArray(this_add_to_cart_product, added_products_array) !== -1) {
        return true; 
      }  
      fetch(`/cart/add.js?id=${this_add_to_cart_product}&quantity=1`, {
          method: 'POST',
          credentials: 'same-origin'  
      }).then(response => {
          // Handle response 
        $('#cartInfo').html( `Products added to the cart successfully.` );
          // console.log(response);
          // console.log('Product added to cart');
        ar_add_to_cart(all_product_ids , ++increment , added_products_array );
        added_products_array[added_products_array.length] = this_add_to_cart_product;
      }).catch(error => {
          // Handle error
          // console.error('Error adding product to cart:', error);
      });
    }

});
  

  // JavaScript/jQuery to handle tab/pill switching
jQuery(document).ready(function() {
  jQuery('.nav-pills a').on('click', function(e) {
    e.preventDefault();
    var collectionToShow = jQuery(this).data('collection');
    
    jQuery('.nav-pills a').removeClass('active');
    jQuery(this).addClass('active');
    
    jQuery('.collection-products').removeClass('active').hide();
    jQuery('#' + collectionToShow).addClass('active').show();
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-tabs-section"] && !window.DesignMode) return;
  try {
    

  // JavaScript/jQuery to handle tab/pill switching
jQuery(document).ready(function() {
  jQuery('.nav-pills a').on('click', function(e) {
    e.preventDefault();
    var collectionToShow = jQuery(this).data('collection');
    
    jQuery('.nav-pills a').removeClass('active');
    jQuery(this).addClass('active');
    
    jQuery('.collection-products').removeClass('active').hide();
    jQuery('#' + collectionToShow).addClass('active').show();
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Custom-bundle"] && !window.DesignMode) return;
  try {
    


  jQuery(document).ready(function($){
   
 

  console.log( ' File Loaded ' );
 
      jQuery(document).on('click' , '.add-all-to-cart' , function(){
          var clk_btn = jQuery(this).closest('div.bundle-products').find('.add-all-to-cart').data('id');
          // console.log( ' Button  Clicked ' );
          var all_product_ids = new Array();
          for( var  incrmentt = 0 ; incrmentt < jQuery(this).closest('div.bundle-products').find('.product-id').length ; incrmentt++ ){
            var current_product_id = $(jQuery(this).closest('div.bundle-products').find('.product-id')[incrmentt]).val(); 
            if( !all_product_ids.includes(current_product_id) ){
              all_product_ids[all_product_ids.length] = current_product_id;
            }
          }
          // console.log( "All Products" );
          // console.log(all_product_ids);
          var added_products_array = new Array(); 
          ar_add_to_cart(all_product_ids , 0 , added_products_array );
                                                          
      });  
 
    function ar_add_to_cart(all_product_ids , increment , added_products_array ){
       // console.log( 'Increment Is -> ' + increment );
       // console.log( 'All Is -> ' + all_product_ids.length ); 
      if( all_product_ids.length == increment + 1 ){
        setTimeout(function() {
            window.location.href =  window.location.origin + '/cart'; 
        }, 1000);
        
      }  
      var this_add_to_cart_product = all_product_ids[increment];
      if( !all_product_ids[increment] ){
        // window.location.href =  window.location.origin + '/cart';
        return true;
      } 
      if ($.inArray(this_add_to_cart_product, added_products_array) !== -1) {
        return true; 
      }  
      fetch(`/cart/add.js?id=${this_add_to_cart_product}&quantity=1`, {
          method: 'POST',
          credentials: 'same-origin'  
      }).then(response => {
          // Handle response 
        $('#cartInfo').html( `Products added to the cart successfully.` );
          // console.log(response);
          // console.log('Product added to cart');
        ar_add_to_cart(all_product_ids , ++increment , added_products_array );
        added_products_array[added_products_array.length] = this_add_to_cart_product;
      }).catch(error => {
          // Handle error
          // console.error('Error adding product to cart:', error);
      });
    }

});

  } catch(e) { console.error(e); }
})();
      })();
